import React, { useEffect, useState } from "react";
import heroBackImageDefault from "./images/hero/hero.webp";
import heroImageDefault from "./images/hero-circle.webp"; // default person image
import userAvatarDefault from "./images/hero-circle.webp"; // default avatar
import "./css/hero.css";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src, fallback) => {
  if (!src) return fallback;
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const Hero = () => {
  const [content, setContent] = useState({
    headingLine1: "نبض كير، شريكك الاستراتيجي",
    headingHighlight: "للعبور بمنتجاتك",
    headingLine2: "إلى الأسواق السعودية",
    descriptionText:
      "في نبض كير نقدّم حلولًا استشارية متكاملة تشمل هيئة الغذاء والدواء، وزارة الصناعة، والتخليص الجمركي، لنضمن لك الامتثال الكامل وتسريع الإجراءات.",
    primaryButtonLabel: "خدماتنا",
    primaryButtonPath: "/services",
    secondaryButtonLabel: "اتصل بنا",
    secondaryButtonUrl: "https://wa.me/+966573394229",
    heroBackgroundUrl: "",
    heroMainImageUrl: "",
    heroAvatarName: "محمد العلي",
    heroAvatarTitle: "مدير الاستشارات",
    stat1Label: "رضا العملاء (99%)",
    stat1Percent: 99,
    stat2Label: "تخليص جمركي (95%)",
    stat2Percent: 95,
  });

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hero`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.hero) {
          setContent((prev) => ({
            ...prev,
            ...data.hero,
          }));
        }
      } catch {
        // fall back to defaults on error
      }
    };

    fetchHero();
  }, []);

  const {
    headingLine1,
    headingHighlight,
    headingLine2,
    descriptionText,
    primaryButtonLabel,
    primaryButtonPath,
    secondaryButtonLabel,
    secondaryButtonUrl,
    heroBackgroundUrl,
    heroMainImageUrl,
    heroAvatarName,
    heroAvatarTitle,
    stat1Label,
    stat1Percent,
    stat2Label,
    stat2Percent,
  } = content;

  const bgImage = resolveImageUrl(heroBackgroundUrl, heroBackImageDefault);
  const mainImage = resolveImageUrl(heroMainImageUrl, heroImageDefault);
  const avatarImage = userAvatarDefault;

  const safePercent = (value, fallback) => {
    const num = typeof value === "number" ? value : parseFloat(value);
    if (Number.isNaN(num) || num < 0) return fallback;
    if (num > 100) return 100;
    return num;
  };

  const stat1Width = `${safePercent(stat1Percent, 99)}%`;
  const stat2Width = `${safePercent(stat2Percent, 95)}%`;

  return (
    <section className="hero">
      <img className="hero-back-image" src={bgImage} alt="Background" />
      <div className="hero-overlay"></div>

      <div className="container">
        <div className="row align-items-center">
          {/* 1. Text Column (Right side for Arabic) */}
          <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-1">
            <div className="hero-content-text">
              <h1>
                {headingLine1}
                <br />
                <span>{headingHighlight}</span>
                <br />
                {headingLine2}
              </h1>
              <p>{descriptionText}</p>

              <div className="hero-buttons">
                {primaryButtonLabel && primaryButtonPath && (
                  <Link to={primaryButtonPath} className="hero-btn filled-btn">
                    {primaryButtonLabel}
                    <i className="fa-solid fa-arrow-left me-2"></i>
                  </Link>
                )}
                {secondaryButtonLabel && secondaryButtonUrl && (
                  <Link to={secondaryButtonUrl} className="hero-btn outlined-btn">
                    {secondaryButtonLabel}
                  </Link>
                )}
              </div>
            </div>
          </div>

          {/* 2. Image Column (Left side for Arabic) */}
          <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-2">
            <div className="hero-image-wrapper">
              {/* The Yellow Circle Background */}
              <div className="hero-blob">
                <img className="hero-main-img" src={mainImage} alt="Consultant" />
              </div>

              {/* Floating Card 1: Profile (Top Left) */}
              <div className="floating-card card-profile">
                <img src={avatarImage} alt="Manager" />
                <div>
                  <h6 style={{ margin: 0, fontSize: "14px" }}>{heroAvatarName}</h6>
                  <span style={{ fontSize: "11px", color: "#ccc" }}>{heroAvatarTitle}</span>
                </div>
              </div>

              {/* Floating Card 2: Stats (Bottom Right) */}
              <div className="floating-card card-stats">
                <h6 style={{ marginBottom: "15px" }}>نشاط العملاء</h6>

                <div className="stat-row">
                  <span className="stat-label">{stat1Label}</span>
                  <div className="progress-bar">
                    <span className="progress-fill" style={{ width: stat1Width }}></span>
                  </div>
                </div>

                <div className="stat-row">
                  <span className="stat-label">{stat2Label}</span>
                  <div className="progress-bar">
                    <span className="progress-fill" style={{ width: stat2Width }}></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;